export const settingLabels = {
  assistantOrganizer: "Assistant Organizer",
  defaultLocation: "Default Location",
  defaultResourceType: "Default Resource Type",
  defaultCategories: "Default Categories",
  quickButton: "Quick button",
  categoryIcon: "Category icons",
  recommendation: "Recommendation screen",
  capacityFilter: "Capacity filter",
  aiAssistant: "AI Assistant",
  tileConfiguration: "Tile configuration",
  help: "Help",
  dateTime: "Date/Time format",
};
